<template>
  <footer class="w-full pt-12 bg-neutral-100 md:bg-white">
    <div class="mx-auto max-w-6xl w-full flex flex-col px-6 md:px-8 xl:px-0">
      <div class="mb-6 ">
        <div class="justify-self-center md:justify-self-start">
          <Logo :url="homepageUrl" @click="handleLogoClick" />
        </div>
      </div>
      <div class="py-6 border-t border-neutral-200 flex md:justify-between flex-col-reverse md:flex-row">
        <div class="flex md:items-center mt-4 md:mt-0 gap-4 md:gap-8 flex-col md:flex-row">
          <div class="justify-center text-neutral-500 text-sm font-normal leading-tight">© {{ currentYear }} 3cket</div>
          <div class="flex md:items-center gap-4 flex-col md:flex-row">
            <div class="flex items-center gap-4">
              <NuxtLink class="text-neutral-500 text-sm font-normal leading-tight" :to="$t('footer.privacy.link')"
                target="_blank">{{ $t('footer.privacy.label') }}</NuxtLink>
              <NuxtLink class="text-neutral-500 text-sm font-normal leading-tight" :to="$t('footer.terms.link')"
                target="_blank">{{ $t('footer.terms.label') }}</NuxtLink>
            </div>
            <NuxtLink class="flex items-center text-neutral-500 text-sm font-normal leading-tight"
              :to="$t('footer.help.link')" target="_blank">
              <span>{{ $t('footer.help.label') }}</span>
              <BaseIcon name="arrow-up-right" class="ml-1" />
            </NuxtLink>
          </div>
        </div>

        <div class="flex md:items-center gap-4 flex-col md:flex-row justify-start">
          <LangDropdown key='navbar' class="flex h-8 md:h-9 text-sm" grey inverse footer />
          <div class="flex items-center gap-2">
            <NuxtLink to="https://www.instagram.com/3cket/" target="_blank">
              <BaseIcon class="text-neutral-500 m-1" filled name="instagram" />
            </NuxtLink>
            <NuxtLink to="https://www.linkedin.com/company/3cket/" target="_blank">
              <BaseIcon class="text-neutral-500 m-1" filled name="linkedin" />
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>

    <Modal v-if="shouldShowExitModal"
           v-model="exitModal"
           :modal="ModalsExit"
    />
  </footer>
</template>
<script lang="ts" setup>
import { ModalsExit } from "#components"

const { homepageUrl, shouldShowExitModal, exitModal, handleLogoClick } = useExitModal()

const currentYear = new Date().getFullYear();
</script>
